import simpleParallax from 'simple-parallax-js';
import matchHeight from 'jquery-match-height';


/**
 * @file
 * Global utilities.
 *
 */
(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.$gissociabilite = {
    attach: function (context, settings) {
      // Vérification du contexte car le fichier est parcouru une 2ème fois avec l'élément HTML de la barre admin
      // comme contexte. En vérifiant que context est bien égal à document, on s'assure que la fonction ne sera lue qu'une fois
      // @see https://drupal.stackexchange.com/a/287227
      if (context === document) {
        $( document ).ready(function() {
          // MatchHeight
          $('.match_height_box').matchHeight();
          // Elevator Up
          $(".elevator_container").on("click", function(e) {
            e.preventDefault();
            $("html").animate({ scrollTop: 0 }, "slow");
          });
          $(window).scroll(function() {
            let scrollTop = $(this).scrollTop();
            let height = $(this).height();
            let opacity = scrollTop / height;
            $('.elevator_container').css('opacity', opacity);
          });
          // Elevator Up
          $(".elevator_container_down").click(function() {
            let headerHeight;
            if ($(window).width() < 992) {
              headerHeight = $('.header_mobile').height();
            } else {
              headerHeight = $('.header_desktop').height();
            }
            $('html, body').animate({
              scrollTop: $("#block-gissociabilite-content").offset().top - headerHeight
            }, 'slow');
          });
          // // Mise en page paragraphe colonne en tablette
          // $('.colonne_container').each(function() {
          //   alert($(this).offset().left);
          //   $(
          //     "<style>" +
          //       ".paragraph--type--paragraphe-2-colonnes.right .left_col::before, " +
          //       ".paragraph--type--paragraphe-2-colonnes.left .right_col::before " +
          //       "{" +
          //         " left: -" + $(this).offset().left + "px!important; " +
          //         " width: " + $(window).width() + "px!important; " +
          //       "}" +
          //     "</style>"
          //   ).appendTo( "head");
          // });
        });
      }
    }
  };
})(jQuery, Drupal, drupalSettings);
